import * as Yup from 'yup';
import * as _ from 'lodash';
import moment from 'moment';

import { validDate } from './dateFieldUtils';

const capitalize = word => word[0].toUpperCase() + word.slice(1);

export const transformErrorMessage = msg => {
  const [field, ...rest] = msg.split(' ');
  const result = `${capitalize(field.replace(/([a-z](?=[A-Z]))/g, '$1 '))} ${rest.join(' ')}`;
  return result;
};

export const extractError = error => {
  if (_.isObject(error)) {
    return _.get(error, ['response', 'error']) ||
      _.get(error, ['message', 'message']) ||
      _.get(error, ['message']);
  }
  return error;
};

export const egrSchema = Yup.object().shape({
  groupId:             Yup.number().typeError('Group Id must be a number').min(1).required(),
  externalGroupId:     Yup.string().required('Vendor Group Id is a required field'),
  externalGroupTypeCd: Yup.string().required(),
  stateCd:             Yup.string(),
  effectiveStartDate:  Yup.string().test('effectiveStartDate', 'effectiveStartDate should be in MM/DD/YYYY format.', function (value) {
    return validDate(value);
  }).required(),
  effectiveEndDate:    Yup.string()
    .test('effectiveEndDate', 'effectiveEndDate should be in MM/DD/YYYY format.', function (value) {
      if (!value) {
        return true;
      }
      return validDate(value);
    })
    .test('effectiveEndDate', 'effectiveEndDate must be after effective start date', function (value) {
      if (!value) {
        return true;
      }
      const { effectiveStartDate } = this.parent;
      return moment(value, 'MM/DD/YYYY').isSameOrAfter(moment(effectiveStartDate, 'MM/DD/YYYY'));
    })
});
